import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { getNationalitiesList } from "./queries";

const NationalitiesContext = createContext({});

export const useNationalitiesContext = () => useContext(NationalitiesContext);

export const NationalitiesProvider = ({ ...props }) => {
  const [nationalitiesList, setNationalitiesList] = useState([]);

  const nationalitiesListGetter = useCallback(async () => {
    try {
      if (nationalitiesList?.length === 0) {
        setNationalitiesList(await getNationalitiesList());
      }
    } catch (e) {
      console.error("nationalitiesListGetter", e);
      throw e;
    }
  }, [nationalitiesList]);

  const values = useMemo(
    () => ({
      nationalitiesList,
      setNationalitiesList,
      nationalitiesListGetter,
    }),
    [nationalitiesList]
  );
  return <NationalitiesContext.Provider value={values} {...props} />;
};
